import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    standalone: true,
    name: 'millisecondsToTime',
    
})
export class MillisecondsToTimePipe implements PipeTransform {

  transform(milliseconds: number): string {
    if (!milliseconds && milliseconds !== 0) return '';

    const hours = Math.floor(milliseconds / (1000 * 60 * 60));
    const minutes = Math.floor((milliseconds % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((milliseconds % (1000 * 60)) / 1000);

    const paddedHours = hours.toString().padStart(2, '0');
    const paddedMinutes = minutes.toString().padStart(2, '0');
    const paddedSeconds = seconds.toString().padStart(2, '0');

    return `${paddedHours}:${paddedMinutes}:${paddedSeconds}`;
  }
}
